module.exports = __webpack_public_path__ + "img/metalDetection_checked.f298680c.png";